import { render, staticRenderFns } from "./v004_auctionRegister.vue?vue&type=template&id=a56d76be&scoped=true&"
import script from "./v004_auctionRegister.vue?vue&type=script&lang=js&"
export * from "./v004_auctionRegister.vue?vue&type=script&lang=js&"
import style0 from "./v004_auctionRegister.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./v004_auctionRegister.vue?vue&type=style&index=1&id=a56d76be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56d76be",
  null
  
)

export default component.exports